var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneActionsRinging = function SvgPhoneActionsRinging(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22694 17.2065L2.84995 18.831C3.69382 19.6746 4.83821 20.1485 6.03144 20.1485C7.22468 20.1485 8.36907 19.6746 9.21294 18.831L11.5994 16.4445C11.8085 16.2355 11.9744 15.9874 12.0876 15.7144C12.2007 15.4413 12.259 15.1486 12.259 14.853C12.259 14.5574 12.2007 14.2647 12.0876 13.9916C11.9744 13.7185 11.8085 13.4704 11.5994 13.2615L6.95994 8.62049C6.73275 8.39131 6.45892 8.21368 6.15702 8.09966C5.85512 7.98563 5.53223 7.93789 5.21026 7.95965C4.88828 7.98142 4.57476 8.0722 4.29096 8.22582C4.00716 8.37944 3.75972 8.59231 3.56545 8.84999C-1.29605 15.45 1.64994 22.401 7.62294 28.377C13.5959 34.353 20.5544 37.296 27.1574 32.4345C27.4146 32.2396 27.6269 31.9918 27.7798 31.7077C27.9328 31.4236 28.0228 31.1099 28.0439 30.788C28.0649 30.466 28.0165 30.1433 27.9018 29.8417C27.7872 29.5401 27.609 29.2667 27.3794 29.04L22.7384 24.399C22.5295 24.1899 22.2814 24.024 22.0083 23.9109C21.7352 23.7977 21.4425 23.7395 21.1469 23.7395C20.8513 23.7395 20.5587 23.7977 20.2856 23.9109C20.0125 24.024 19.7644 24.1899 19.5554 24.399L17.1704 26.7855C16.7525 27.2034 16.421 27.6995 16.1948 28.2455C15.9686 28.7915 15.8522 29.3767 15.8522 29.9677C15.8522 30.5588 15.9686 31.144 16.1948 31.69C16.421 32.236 16.7525 32.7321 17.1704 33.15L18.8099 34.791",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 12.375C18.6652 12.375 20.3821 13.0862 21.648 14.352C22.9138 15.6179 23.625 17.3348 23.625 19.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.75C20.1571 6.75 23.3047 8.05379 25.6254 10.3746C27.9462 12.6953 29.25 15.8429 29.25 19.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 1.125C21.6489 1.125 26.2273 3.02142 29.6029 6.39708C32.9786 9.77273 34.875 14.3511 34.875 19.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneActionsRinging, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-actions-ringing.6b371d6b.svg";
export { ForwardRef as ReactComponent };